var $ = jQuery;